import { render, staticRenderFns } from "./NLPInput.vue?vue&type=template&id=15e34fc5&"
import script from "./NLPInput.vue?vue&type=script&lang=js&"
export * from "./NLPInput.vue?vue&type=script&lang=js&"
import style0 from "./NLPInput.vue?vue&type=style&index=0&id=15e34fc5&prod&lang=scss&"


/* normalize component */
import normalizer from "!../../node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports